import React from "react";

const Truncate = ({ text, maxLength = 10 }) => {
  if (!text) return null;

  const truncatedText =
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return <span title={text}>{truncatedText}</span>;
};

export default Truncate;